export default "__VITE_ASSET__Ds5TV2nj__"